import React from "react";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { updatedRequest } from "./constant";

export const getEmprCancellationList = async (
  page = 0,
  filterObj = {},
  setLoader,
  businessAreaDropdown
) => {
  const req = updatedRequest(filterObj,businessAreaDropdown);
  try {
    setLoader(true);
    const res = await fetchAllPostPromisedData(
      `${endpoint.epmrReceipt.search}?offset=${page}`,
      req,
      "post"
    );
    if (res.code == 200) {
      return res?.data;
    } else {
      return;
    }
  } catch (error) {
    console.log(error);
  } finally {
    setLoader(false);
  }
};

export const getAllActivePaymentMode = async () => {
  const url = endpoint?.paymentMode?.getActive;
  try {
    const res = await fetchAllPromisedData(url, true);

    if (res?.code == 200) {
      return res?.data.map((item) => ({
        label: item?.paymentModeKey,
        value: item?.id,
      }));
    }
  } catch (error) {
    console.log(error);
  }
};
export const submitstatusHandler = async (req) => {
  try {
    return await fetchAllPostPromisedData(
      `${endpoint.epmrReceipt.updateStatus}`,
      req,
      "put"
    );
  } catch (error) {
    console.log(error);
  }
};
export const getRemarksByEpmrNumber= async(epmrNumber)=>{
    try{
        return await fetchAllPromisedData(`${endpoint?.epmrReceipt?.audit}?epmrNumber=${epmrNumber}`,true)
    }
    catch(error){
        console.log(error)
    }
}